import { visT } from "views/components/visualizations/visualizationTranslation";
import PieVisualization from "views/components/visualizations/pie/PieVisualization";
import { hasAtLeastOneMetric } from "views/components/visualizations/validations";
const validate = hasAtLeastOneMetric("vis_validation.pie_chart_requires_metric");
const pieChart = {
  type: PieVisualization.type,
  get displayName() {
    return visT("vis_types.pie_chart");
  },
  component: PieVisualization,
  validate
};
export default pieChart;
